import React from 'react';

// Styles & Assets
import styles from './AdherenceCells.module.css';

// Services
import { sortArray } from '../../../services/sort';

// Interfaces
import { DrugAdministration, DrugAdministrationList } from '../../../interfaces/Drug';

const AdherenceCells: React.FC<{
    drug: DrugAdministrationList,
    hour?: string
}> = ({ drug, hour }) => {

    const hoursDose = Object.keys(drug.hours);

    const calculatePercentage = (drugAdmin: { [date: string]: DrugAdministration[] }, totalDays: boolean) => {
        // sort reverse
        const keys = totalDays ?
            Object.keys(drugAdmin)
            :
            sortArray(Object.keys(drugAdmin), false).slice(0, 7);
        return Math.round(keys.filter(timestamp => {
            return drugAdmin[timestamp][0].status === 'administred';
        }).length / keys.length * 100);
    };

    const getMeanPercentage = (totalDays: boolean) => {
        let percentages = 0;
        hoursDose.forEach(hour => {
            percentages += calculatePercentage(drug.hours[hour], totalDays);
        });
        return Math.round(percentages / hoursDose.length);
    };
    
    return (
        <>
            <td className={`${styles.adhesion7} pharmaCell blueCell`}>
                {hour === undefined ? getMeanPercentage(false) : calculatePercentage(drug.hours[hour], false)}%
            </td>
            <td className={`${styles.adhesionTotal} pharmaCell blueCell`}>
                {hour === undefined ? getMeanPercentage(true) : calculatePercentage(drug.hours[hour], true)}%
            </td>
        </>
    );
};

export default AdherenceCells;